module.exports = __webpack_public_path__ + "static/media/gwp_60yd_n-1.369dfb0a.csv";